package co.maytes.standupbot.dashboard.stores

import androidx.compose.runtime.Composable
import androidx.compose.runtime.ReadOnlyComposable
import androidx.compose.runtime.compositionLocalOf
import co.maytes.standupbot.dashboard.features.auth.AuthContainer
import co.maytes.standupbot.dashboard.features.setup.SetupCheckStore
import co.maytes.standupbot.dashboard.features.setup.SetupStatusStore
import co.maytes.standupbot.dashboard.lib.api.ApiClient

val LocalApiClient = compositionLocalOf<ApiClient> {
    error("ApiClient not provided — wrap your tree in AppEntry")
}

val LocalAuthStore = compositionLocalOf<AuthContainer> {
    error("AuthContainer not provided — wrap your tree in AppEntry")
}

val LocalUiStore = compositionLocalOf<UiContainer> {
    error("UiContainer not provided — wrap your tree in AppEntry")
}

val LocalSetupStatusStore = compositionLocalOf<SetupStatusStore> {
    error("SetupStatusStore not provided — wrap your tree in AppEntry")
}

val LocalSetupCheckStore = compositionLocalOf<SetupCheckStore> {
    error("SetupCheckStore not provided — wrap your tree in AppEntry")
}

@Composable
@ReadOnlyComposable
fun rememberApiClient(): ApiClient = LocalApiClient.current

@Composable
@ReadOnlyComposable
fun rememberSetupCheckStore(): SetupCheckStore = LocalSetupCheckStore.current

@Composable
@ReadOnlyComposable
fun rememberSetupStatusStore(): SetupStatusStore = LocalSetupStatusStore.current

@Composable
@ReadOnlyComposable
fun rememberAuthStore(): AuthContainer = LocalAuthStore.current

@Composable
@ReadOnlyComposable
fun rememberUiStore(): UiContainer = LocalUiStore.current
